import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** notification bell. Decorative line icon; always pair with a visible text label. */
export function BellIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M18 9.5a6 6 0 1 0-12 0c0 5.5-2.5 6.5-2.5 6.5h17S18 15 18 9.5z" />
      <path d="M10 20a2.2 2.2 0 0 0 4 0" />
    </IconSvg>
  )
}
